import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { BUYABLE_TYPE, calculateClientBuyableFeePolicy } from '@fiverr-private/price_upfront_sdk';
import { POLICY_TO_KEY } from '../../../GigCards/Components/Price/Price.constants';
import { AppI18n } from '../../../i18n';

export const PriceUpfrontTooltip = () => {
    const priceUpfrontKey = POLICY_TO_KEY[calculateClientBuyableFeePolicy(BUYABLE_TYPE.GIG)];

    if (!priceUpfrontKey) {
        return null;
    }

    return (
        <Stack direction="column">
            <Text fontWeight="bold" size="b_sm" color="white">
                <AppI18n k={`gig_cards.price.${priceUpfrontKey}.title`} />
            </Text>
            <Text size="b_sm" color="white">
                <AppI18n k={`gig_cards.price.${priceUpfrontKey}.description`} />
            </Text>
        </Stack>
    );
};
